// Module
var code = "<table class=\"table report-table\">\n    <thead></thead>\n    <tfoot>\n        <tr><td colspan=\"5\"></td></tr>\n    </tfoot>\n    <tbody></tbody>\n</table>";
// Exports
module.exports = code;